import { render } from "./ElencoOrdini.vue?vue&type=template&id=916ded72&scoped=true"
import script from "./ElencoOrdini.vue?vue&type=script&lang=js"
export * from "./ElencoOrdini.vue?vue&type=script&lang=js"

import "./ElencoOrdini.vue?vue&type=style&index=0&id=916ded72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916ded72"]])

export default __exports__